import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [userId, setUserId] = useState(null);
    const [activityList, setActivityList] = useState([]);
    const [currentActivity, setCurrentActivity] = useState(-1);
    const [loadingSession, setLoadingSession] = useState(true);
    
    const checkSession = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/session?role=patient`, {
                withCredentials: true
            });
            
            if (response.data?.userId) {
                setUserId(response.data.userId);
            } else {
                setUserId(null);
            }
        } catch (err) {
            console.warn("Failed to check session:", err);
            setUserId(null);
        } finally {
            setLoadingSession(false);
        }
    };
    
    useEffect(() => {
        checkSession().then(() => {});
    }, []);
    
    const logout = () => {
        setUserId(null);
        setActivityList([]);
        setCurrentActivity(-1);
    };
    
    return (
        <AppContext.Provider value={{
            userId,
            logout,
            activityList,
            setActivityList,
            currentActivity,
            setCurrentActivity,
            loadingSession,
            checkSession
        }}>
            {children}
        </AppContext.Provider>
    );
};